import { useEffect, useState } from 'react';
import "../../styles/navbar/nav.css"
import { Link, NavLink, useLocation } from 'react-router-dom';
import { LuMenu, LuX, LuExternalLink } from "react-icons/lu";


const NAV_LINKS = [
  { to: "/club", label: "Le club" },
  { to: "/infoscription", label: "Informations", subPages: ["/registration", "/registrationHelp"] },
  { href: "https://www.blvb.fr/blvb/", label: "BLVB" },
  { to: "/beach", label: "Beach" },
  { to: "/events", label: "Actualités" },
  { to: "/partners", label: "Partenaires" },
  { to: "/contact", label: "Contact" },
];


function Nav() {

  const [showLinks, setShowLinks] = useState(false);
  const location = useLocation();

  //FERMER LE MENU MOBILE À CHAQUE CHANGEMENT DE PAGE
  useEffect(() => {
    setShowLinks(false)
  }, [location.pathname]);

  //FERMER LE MENU MOBILE AVEC LA TOUCHE ÉCHAP
  useEffect(() => {
    if (!showLinks) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setShowLinks(false)
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [showLinks]);

  const links = NAV_LINKS.map((link) => (
    <li key={link.label} className="navbar_item">
      {link.href
        ? <a href={link.href} className="navbar_link" target="_blank" rel="noopener noreferrer">
          {link.label}
          <LuExternalLink aria-hidden="true" className="navbar_external_icon" />
          <span className="sr-only">(nouvel onglet)</span>
        </a>
        : <NavLink
          to={link.to}
          //LE LIEN RESTE ACTIF SUR SES SOUS-PAGES (ex. "Informations" sur la page d'inscription)
          className={({ isActive }) => `navbar_link ${isActive || link.subPages?.includes(location.pathname) ? "active" : ""}`}
        >
          {link.label}
        </NavLink>}
    </li>
  ));

  return (
    <header className={`navbar ${showLinks ? "navbar--open" : ""}`}>
      <div className="navbar_inner">
        <Link to="/" className="navbar_brand" aria-label="VBLC, retour à l'accueil">
          <img className="navbar_logo" src="/images/logo_vblc_new.png" alt="" />
          <span className="navbar_brand_text">
            <span className="navbar_acronym">VBLC</span>
            <span className="navbar_name">Volley-Ball Luzien Cibourien</span>
          </span>
        </Link>

        <nav id="main-menu" className="navbar_menu" aria-label="Menu principal">
          <ul className="navbar_links">
            {links}
          </ul>
          <Link to="/registration" className="btn btn--primary navbar_cta">S’inscrire</Link>
        </nav>

        <button
          className="navbar_burger"
          onClick={() => setShowLinks(!showLinks)}
          aria-expanded={showLinks}
          aria-controls="main-menu"
          aria-label={showLinks ? "Fermer le menu" : "Ouvrir le menu"}
        >
          {showLinks ? <LuX aria-hidden="true" /> : <LuMenu aria-hidden="true" />}
        </button>
      </div>
    </header>
  );
}

export default Nav;
